import React from "react";

import { SkeletonText } from "~/components/skeleton/text";
import { pluralize } from "~/tools/pluralize";

import type { DashboardWidgetSpecInitConfig } from "../../common/dashboard-spec";
import { DASHBOARD_PATH } from "../../routes/Routes";
import { initSetupDashboardFormState } from "../_setup-dashboard-drawer";
import { useExplorationDrawerState } from "../react/drawer/use-exploration-drawer-state";
import { Link, useNavigateToLinkLazy } from "../react/link";
import { notification } from "../react/notification/Notification";

import { DashboardEntry } from "./_dashboard-entry";

const pluralizeSuccessToast = pluralize({
	1: "widget has",
	more: "widgets have",
});

export interface NewDashboardEntryProps {
	interactive: boolean;
	widgets: ReadonlyArray<DashboardWidgetSpecInitConfig>;
	close: VoidFunction;
}

export const NewDashboardEntry: React.FC<NewDashboardEntryProps> = ({ interactive, widgets, close }) => {
	const navigateToLink = useNavigateToLinkLazy();
	const explorationDrawer = useExplorationDrawerState();

	return (
		<DashboardEntry
			interactive={interactive}
			onClick={() => {
				explorationDrawer.openSetupDashboard({
					type: "create",
					widgets,
					form: initSetupDashboardFormState({
						name: "",
						description: "",
						starred: false,
						publiclyAccessible: false,
					}),
					onSuccess: ({ id, name }) => {
						const destination = navigateToLink(DASHBOARD_PATH, {
							params: { idOrIdentifier: id },
							search: ["timeRange", "timestamp", "detachedFilters"],
						});

						notification.success({
							duration: 5,
							message: (
								<p>
									The {pluralizeSuccessToast(widgets.length)} been successfully added to new "
									{/* it can use Router.Link here because the notification is out of Router context */}
									<Link el="a" href={`#${destination}`} theme="secondary">
										{name}
									</Link>
									" dashboard.
								</p>
							),
						});
						close();
					},
				});
			}}
		>
			<SkeletonText randomize when={interactive ? "Add new dashboard" : undefined} />
		</DashboardEntry>
	);
};
